import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import { Answer, Question } from "../../types/models";

type Props = {
  question: Question;
  answer: Answer | undefined;
};

export const QuestionTableActionsButton: FC<Props> = ({ question, answer }) => {
  const { chapterNum } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(`/chapter/${chapterNum}/question/${question.number}`);
  };

  const label =
    answer === undefined
      ? t("chapter.actions.start")
      : answer.completed
      ? t("chapter.actions.edit")
      : t("chapter.actions.resume");

  const color =
    answer === undefined ? "delicate" : answer.completed ? "rust" : "sand";

  const colorVariants = {
    delicate: "border-delicate-50 hover:bg-delicate-10 text-delicate-700",
    rust: "border-rust-50 hover:bg-rust-10 text-rust-700",
    sand: "border-sand-50 hover:bg-sand-10 text-sand-700",
  };

  return (
    <button
      type="button"
      className={[
        "px-3 sm:px-6 py-1 inline-flex text-xs sm:text-sm lg:text-base leading-4 sm:leading-5 font-normal rounded-full border-2",
        colorVariants[color],
      ].join(" ")}
      onClick={() => handleNavigate()}
    >
      <span className="hidden sm:inline">{label}</span>
      <span className="sm:hidden">
        {answer === undefined ? "▶" : answer.completed ? "✏" : "⏸"}
      </span>
    </button>
  );
};
